module.exports = __webpack_public_path__ + "img/yj.8fe4acf6.png";